// inspired by: https://ng-bootstrap.github.io/stackblitzes/toast/howto-global/stackblitz.html
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Toast, ToastOptions } from './models/toast.model';
import { IToastie } from '@era/stores';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly _toasts$ = new BehaviorSubject<Toast[]>([]);
  readonly toasts$ = this._toasts$.asObservable();

  show(text: string, options?: ToastOptions): void {
    const newToast: Toast = {
      id: crypto.randomUUID(),
      text: text,
      options: {
        classname: options?.classname,
        delay: options?.delay ?? 5000,
        autohide: options?.autohide ?? true,
      },
    };
    this._toasts$.next([...this._toasts$.value, newToast]);
  }

  showSuccess(text: string): void {
    this.show(text, { classname: 'bg-success text-white' });
  }

  showError(text: string): void {
    this.show(text, { classname: 'bg-danger text-white' });
  }

  showInfo(text: string): void {
    this.show(text, { classname: 'bg-info text-dark' });
  }

  showWarning(text: string): void {
    this.show(text, { classname: 'bg-warning text-dark' });
  }

  remove(id: string): void {
    this._toasts$.next(this._toasts$.value.filter((t) => t.id !== id));
  }

  clear(): void {
    this._toasts$.next([]);
  }

  showToastie(toastie: IToastie): void {
    switch (toastie.toastType) {
      case 'success':
        this.showSuccess(toastie.message);
        break;
      case 'error':
        this.showError(toastie.message);
        break;
      case 'info':
        this.showInfo(toastie.message);
        break;
      case 'warning':
        this.showWarning(toastie.message);
        break;
    }
  }
}
